import type { FilterOperator } from "@/components/search/FilterBox/types";

type SearchHelperFacetState = {
  facetsRefinements?: Record<string, string[]>;
  disjunctiveFacetsRefinements?: Record<string, string[]>;
};

const getFacetRefinementsFromSearchState = ({
  searchState,
  attributeName,
  facetOperator,
}: {
  searchState: SearchHelperFacetState | undefined;
  attributeName: string;
  facetOperator: FilterOperator;
}): string[] => {
  if (!searchState) {
    return [];
  }

  const conjunctiveRefinements = searchState.facetsRefinements?.[attributeName];
  const disjunctiveRefinements = searchState.disjunctiveFacetsRefinements?.[attributeName];

  if (facetOperator === "or") {
    return disjunctiveRefinements ?? conjunctiveRefinements ?? [];
  }

  return conjunctiveRefinements ?? disjunctiveRefinements ?? [];
};

export default getFacetRefinementsFromSearchState;
